import dayjs from 'dayjs';
import {
  NEXT_DAY_PROMO_DAY_TABS,
  ORDER_TYPE_CLOUD_KITCHEN,
  ORDER_TYPE_NEXT_DAY_PROMOTION,
  ORDER_TYPE_RESTAURANT,
  STATUS_TABS,
} from '../orderManagementConfig';

const ORDER_SOURCE_LABELS = {
  [ORDER_TYPE_RESTAURANT]: 'Restaurant',
  [ORDER_TYPE_NEXT_DAY_PROMOTION]: 'Next day Promotion',
  [ORDER_TYPE_CLOUD_KITCHEN]: 'Cloud Kitchen',
};

const DELIVERY_TYPE_LABELS = {
  all: 'All types',
  'home delivery': 'Home delivery',
  pickup: 'Pickup',
};

export function formatDeliveryDateDisplay(mdy) {
  const s = String(mdy ?? '').trim();
  if (!s) return '—';
  const parsed = dayjs(s, 'MM/DD/YYYY', true);
  if (parsed.isValid()) return parsed.format('MMM D, YYYY');
  return s;
}

/** Dates sent to GetRestaurantOrders / GetNextDayPromoStoreOrders. */
export function getApiFetchDateLabel({ orderTypeView, deliveryDate, nextDayPromoDateLabel }) {
  if (orderTypeView === ORDER_TYPE_RESTAURANT) {
    return {
      label: 'API delivery date',
      value: formatDeliveryDateDisplay(deliveryDate),
      raw: deliveryDate,
    };
  }
  if (orderTypeView === ORDER_TYPE_NEXT_DAY_PROMOTION) {
    return {
      label: 'API date range',
      value: nextDayPromoDateLabel || '—',
      raw: nextDayPromoDateLabel,
    };
  }
  return {
    label: 'API date',
    value: '—',
    raw: null,
  };
}

export function getActiveFilterChips({
  orderTypeView,
  statusFilter,
  deliveryTypeFilter,
  orderIdSearch,
  nextDayPromoDayFilter,
  isNextDayPromo,
}) {
  const chips = [];

  chips.push({
    key: 'source',
    label: 'Source',
    value: ORDER_SOURCE_LABELS[orderTypeView] ?? orderTypeView,
  });

  if (orderTypeView === ORDER_TYPE_CLOUD_KITCHEN) {
    return chips;
  }

  if (isNextDayPromo) {
    const dayTab = NEXT_DAY_PROMO_DAY_TABS.find((t) => t.value === nextDayPromoDayFilter);
    chips.push({
      key: 'promo-day',
      label: 'Day',
      value: dayTab?.label ?? nextDayPromoDayFilter,
    });
  }

  if (statusFilter && statusFilter !== 'all') {
    const statusOpt = STATUS_TABS.find((t) => t.value === statusFilter);
    chips.push({
      key: 'api-status',
      label: 'API status',
      value: statusOpt?.label ?? statusFilter,
    });
  }

  if (deliveryTypeFilter && deliveryTypeFilter !== 'all') {
    chips.push({
      key: 'delivery',
      label: 'Delivery',
      value: DELIVERY_TYPE_LABELS[deliveryTypeFilter] ?? deliveryTypeFilter,
    });
  }

  const q = String(orderIdSearch ?? '').trim();
  if (q) {
    chips.push({
      key: 'search',
      label: 'Search',
      value: `"${q}"`,
    });
  }

  return chips;
}
